import React from "react";
import ReportTextField from "../report-text-field/report-text-field"; 

const ReportViewPage = (props) => {

    return (
            <div>
                <ReportTextField />
            </div>
    )
}

export default ReportViewPage;